import type { FilterPanelSaveButtonProps } from "./types-save-button";
import { useFilterPanelSaveButton } from "./use-save-button";
import { FilterPanelSaveButtonView } from "./view-save-button";

export function FilterPanelSaveButton(props: FilterPanelSaveButtonProps) {
  const viewModel = useFilterPanelSaveButton(props);

  return <FilterPanelSaveButtonView {...viewModel} />;
}
FilterPanelSaveButton.displayName = "FilterPanel.SaveButton";
